import { useMemo } from 'react';
import { buildSelectOptions } from '@ion/mrdash';

export default function useSchemaSelectOptions(schemas) {
  return useMemo(() => buildSelectOptions({ items: schemas, valueKey: 'id', labelKey: 'name' }), [schemas]);
}
